import React from 'react';
import { WorkflowCatalogId } from '../FolderTree/FolderTreeUtils';
import { getActions, getSideBarWidth, usePortalStore } from 'domains/portal/PortalStore';

export function NoWorkflowsMessage() {
  const { navigateToFolder } = usePortalStore(getActions);
  const sidePanelWidth = usePortalStore(getSideBarWidth) - 20 + 'px'; // - padding 10px

  return (
    <div style={{ maxWidth: sidePanelWidth }} className="dp-no-workflows-message">
      <div className="dp-no-workflows-message__image" />
      <div className="dp-no-workflows-message__top">
        <h3 className="dp-no-workflows-message__header"> Nothing magical here... yet </h3>
        <span> To learn how to create and use Workflow Catalog items, go to&nbsp;</span>
        <br />
        <a
          className="dp-no-workflows-message__link"
          target="_blank"
          rel="noreferrer"
          href="https://documentation.decisions.com/v8/docs/workflow-catalog-overview"
        >
          documentation article
        </a>
        .
      </div>
      <div className="dp-no-workflows-message__bottom">
        To create your first catalog item go&nbsp;
        {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a onClick={() => navigateToFolder(WorkflowCatalogId)} className="dp-no-workflows-message__link">
            here
          </a>
        }
        <br />
        <span className="dp-no-workflows-message__path"> System / Applications / Workflow Catalog </span>
      </div>
    </div>
  );
}
